import { Box, Button, Column, Expanded, Row, Typography } from '@tempmee/react';
import history from '~/browserHistory';
import ArrowDownIcon from '~/images/icons/ArrowDown';
import BulbIcon from '~/images/icons/BulbIcon';
import EditPencilIcon from '~/images/icons/EditPencil';
import { Colors } from '~/themes/colors';

// no DS props for backgroundColor, borderRadius
const CARD_SURFACE_STYLE = {
  backgroundColor: Colors.secondary_25,
  borderRadius: 8,
} as const;

// no DS prop for borderBottom
const HEADER_BORDER_STYLE = { borderBottom: `1px solid ${Colors.neutral_100}` } as const;

// no DS prop for cursor
const RETURN_CLICKABLE_STYLE = { cursor: 'pointer' } as const;

// no DS prop for transform
const ARROW_ROTATED_STYLE = { transform: 'rotate(90deg)' } as const;

type TBackTipsCardProps = {
  localDate: Date;
  onReturnClick: () => void;
};

export default function BackTipsCard({ localDate, onReturnClick }: TBackTipsCardProps) {
  return (
    <Column width="100%" height="100%" style={CARD_SURFACE_STYLE}>
      {/* Header */}
      <Row justify="between" align="center" pl={4} pr={4} pt={4} pb={4} style={HEADER_BORDER_STYLE}>
        <Row align="center" gap={2} style={RETURN_CLICKABLE_STYLE} onClick={onReturnClick}>
          <Box style={ARROW_ROTATED_STYLE}>
            <ArrowDownIcon />
          </Box>
          <Typography as="span" size="heading_4" bold color={Colors.secondary_500}>
            Return
          </Typography>
        </Row>
        <Row align="center" gap={1}>
          <BulbIcon color={Colors.secondary_500} />
          <Typography as="span" size="heading_4" bold color={Colors.primary_500}>
            Tips!
          </Typography>
        </Row>
      </Row>

      {/* Body — grows to fill available height */}
      <Expanded>
        <Column pl={6} pr={4} pt={2}>
          <Typography as="span" size="body_large" color={Colors.neutral_600}>
            Boost your chances of filling this shift! We recommend increasing the hourly rate beyond
            the industry average on shifts posted within <b>36 hours</b> from its starting time.
            <br />
            Click &quot;Edit&quot; to bump the rate higher.
          </Typography>
        </Column>
      </Expanded>

      {/* Footer — Edit button right-aligned */}
      <Row justify="end" pr={4} pb={4}>
        <Button
          type="button"
          variant="ghost"
          size="inline"
          LeadingIcon={<EditPencilIcon color={Colors.secondary_500} />}
          onClick={() =>
            history.push('/dashboard/multi-day/edit', {
              editedDate: localDate,
              defaultOpenCardIndex: 'rate',
            })
          }
        >
          <Typography as="span" size="heading_4" bold color={Colors.secondary_500}>
            Edit
          </Typography>
        </Button>
      </Row>
    </Column>
  );
}
